module.exports = __webpack_public_path__ + "img/csharp.01aeba5a.png";